import { createStore } from 'vuex'

// Cargar todos los módulos dentro de store/api
import reserva from './api/reserva'
import precio from './api/precio'
import diaHabilitado from './api/diaHabilitado'
import auth from './api/auth'
import galeria from './api/galeria'
import mercadoPago from './api/mercadoPago'
import variable from './api/variable'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    reserva,
    precio,
    diaHabilitado,
    auth,
    galeria,
    mercadoPago,
    variable
  }  // Aquí se agregan los módulos dinámicamente
})
